import "starknet";
import { A as p, i as n } from "./index-70f373da.js";
import "./lastConnected-b964dc30.js";
import "./publicRcpNodes-be041588.js";
export {
  p as ArgentMobileConnector,
  n as isInArgentMobileAppBrowser
};
